(function () {
    "use strict";

    var root = document.querySelector(".collection-grids-section");

    if (!root) {
      var gloProductEl = document.querySelector("[data-featured-product]");
      if (!gloProductEl) return;
      root = gloProductEl;
    }

    /* Scroll reveal */
    var revealEls = root.querySelectorAll(".reveal");
    if (revealEls.length && "IntersectionObserver" in window) {
      var io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (e) {
            if (e.isIntersecting) {
              e.target.classList.add("in");
              io.unobserve(e.target);
            }
          });
        },
        { threshold: 0.15 }
      );
      revealEls.forEach(function (el) {
        io.observe(el);
      });
    } else {
      revealEls.forEach(function (el) {
        el.classList.add("in");
      });
    }
  
  })();
  